// extracted by mini-css-extract-plugin
export default {"wraper":"Team_wraper__EEZE3","person":"Team_person__XMRe7","name":"Team_name__Us3VG","dziubek":"Team_dziubek__jZ-hC"};